import ControlChevronLeft from "./control-chevron-left.png";
import DollarCoinIcon from "./icons8-dollar-coin-80.png";
import GraphIcon from "./icons8-graph-32.png";
import DoughnutChartIcon from "./icons8-doughnut-chart-50.png";
import ChinaFlag from "./china.png";
import EnglishFlag from "./united-kingdom.png";

export { ControlChevronLeft, DollarCoinIcon, GraphIcon, DoughnutChartIcon, ChinaFlag, EnglishFlag };
